// extracted by mini-css-extract-plugin
export default {"container":"ActiveSelectionView_container__J3bdC","name":"ActiveSelectionView_name__aoZmJ"};